import ApiService from './api.service';

const api = new ApiService('/billing/mercadopago');
const manualApi = new ApiService('/billing/manual');

/**
 * Precio mensual y si MP está configurado en el servidor (token + precio).
 */
export async function getBillingPublicConfig() {
  const { data, status } = await api.get('/public-config');
  return { data, status };
}

/** Checkout Pro — un mes; `plan` = basic | intermediate | premium (default: plan de la empresa). */
export async function createLicenseMercadoPagoPreference(body = {}) {
  return api.post('/preference', body);
}

/** Suscripción con débito automático mensual (preapproval). */
export async function createLicenseMercadoPagoPreapproval(body = {}) {
  return api.post('/preapproval', body);
}

/** Crear / reutilizar solicitud de pago manual (OWNER). */
export async function createManualPaymentRequest(body = {}) {
  return manualApi.post('/requests', body);
}

/** Listar solicitudes propias. */
export async function listManualPaymentRequests() {
  return manualApi.get('/requests');
}

/** Solicitud pending_review activa (si hay). */
export async function getActiveManualPaymentRequest() {
  return manualApi.get('/requests/active');
}

/** Cancelar solicitud propia en pending_review. */
export async function cancelManualPaymentRequest(requestId) {
  const id = encodeURIComponent(String(requestId || '').trim());
  return manualApi.post(`/requests/${id}/cancel`, {});
}

export function newManualClientRequestId() {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID().replace(/-/g, '').slice(0, 32);
  }
  return `req_${Date.now()}_${Math.random().toString(36).slice(2, 12)}`;
}
